var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mb-4"},[_c('div',{staticClass:"card-body"},[[_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"container"}},[_c('canvas',{attrs:{"id":_vm.name}})])]],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f3d8aa3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/QuizResponseChart.vue
// module id = TxJB
// module chunks = 0 1